import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { OfferService } from '../offer/offer.service';
import { Collection } from './../offer/offer.model';
import { environment } from '../../environments/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-collections',
  templateUrl: 'collections.component.html',
  styleUrls: ['collections.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CollectionsComponent implements OnInit, OnDestroy {

  public path_offer = '';
  public slug: string;
  public pageTitle: string;
  public pageContent: string;
  public collections: Collection[];
  public sub: Subscription = null;
  public cdn = environment.cdn;

  constructor(private router: Router, private route: ActivatedRoute, private cdr: ChangeDetectorRef, private offerService: OfferService) {
    this.path_offer = this.router.config.find(r => r.data?.module === 'OfferModule' && +r.data.level === 0)?.path || '/';
  }

  ngOnInit() {
    this.slug = this.router.url.substr(this.router.url.lastIndexOf('/') + 1);
    this.pageTitle = this.route.snapshot.data.name;
    this.pageContent = this.route.snapshot.data.content;

    this.fetchCollection();
  }

  fetchCollection() {
    this.sub = this.offerService.collections({front: true}).subscribe(collections => {
      this.collections = collections.items || null;
      this.cdr.detectChanges();
    }, error => {
      // console.log(error);
    });
  }

  convertWord(liczba) {

    const pojedyncza = $localize `produkt`;
    const mnoga = $localize `produkty`;
    const mnoga_dopelniacz = $localize `produktów`;

    liczba = Math.abs(liczba);
    if (liczba === 1) {
      return pojedyncza;
    }
    const reszta10 = liczba % 10;
    const reszta100 = liczba % 100;
    if (reszta10 > 4 || reszta10 < 2 || (reszta100 < 15 && reszta100 > 11)) {
      return mnoga_dopelniacz;
    }
    return mnoga;
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

}
